import { AdminRole, UserRole, UserStatus } from "@/types";

export const formatAdminRoleToName = (role: AdminRole) => {
  switch (role) {
    case AdminRole.ADMIN: {
      return "Admin";
    }

    case AdminRole.SUPER_ADMIN: {
      return "Admin+";
    }

    case AdminRole.VETTING_ADMIN: {
      return "Vetting Admin";
    }
  }
};

export const formatUserRoleToName = (role: UserRole) => {
  switch (role) {
    case UserRole.ALPHA: {
      return "Alpha";
    }

    case UserRole.MUSE: {
      return "Muse";
    }
  }
};

export const formatUserStatus = (status: UserStatus) => {
  switch (status) {
    case UserStatus.ACTIVE: {
      return "Active";
    }
    case UserStatus.PENDING:
    case UserStatus.NOT_FINISHED_PROFILE:
    case UserStatus.NOT_ONBOARDED:
    case UserStatus.REJECTED:
    case UserStatus.INACTIVE: {
      return "Inactive";
    }
  }
};

export const formatName = (firstName: string, lastName: string) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  } else {
    return firstName || lastName || "Not-onboarded";
  }
};

export const formatInstProfile = (link: string) => {
  return link.replace("https://www.instagram.com/", "");
};

export const formatEmail = (email: string): string => {
  // Normalize email by trimming whitespace and converting to lowercase
  return email.trim().toLowerCase();
};
